import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getCompaniesListApi } from '@src/api';
import { GetCompaniesParams } from '@src/api/companies/companies';
import {
  completeOrderByIdApi,
  createCashApi,
  getOrderListApi,
  receiveOrderByIdApi,
  updateVoucherDepositApi,
} from '@src/api/orders';
import { NewCash } from '@src/api/orders/orders';

export const getOrderListThunk = createAsyncThunk(
  'orderList/getOrderList',
  async (
    params: {
      page?: number;
      limit?: number;
      sortBy?: string[];
      filter?: { state?: string; method?: string; company?: { id?: number } };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await getOrderListApi(params);
      return response.result?.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const receiveOrderThunk = createAsyncThunk(
  'orderList/receiveOrder',
  async (orderId: number, { rejectWithValue }) => {
    try {
      const response = await receiveOrderByIdApi({ orderId });
      return response.result;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const completeOrderThunk = createAsyncThunk(
  'orderList/completeOrder',
  async (
    { orderId, amount }: { orderId: number; amount: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await completeOrderByIdApi({ orderId, amount });
      return response.result;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const updateVoucherDeposit = createAsyncThunk(
  'orderList/voucherDeposit',
  async (
    {
      isDeposit,
      orderId,
      purchaseNumber,
    }: {
      isDeposit: boolean;
      orderId: number;
      purchaseNumber: string;
    },
    { rejectWithValue }
  ) => {
    try {
      await updateVoucherDepositApi({ isDeposit, orderId, purchaseNumber });
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const getCompanyListThunk = createAsyncThunk(
  'orderList/getCompanyList',
  async (params: GetCompaniesParams, { rejectWithValue }) => {
    try {
      const response = await getCompaniesListApi(params);
      return response.result?.data.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const createCash = createAsyncThunk(
  'cash/createCash',
  async (data: NewCash, { rejectWithValue }) => {
    try {
      const response = await createCashApi({ ...data, method: 'ADMIN' });
      return response.result;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw rejectWithValue(error.response?.data);
      }
    }
  }
);
